import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/**
 *  SEO 설정 및 최적화를 위한 컴포넌트
 *  */
function Seo(): JSX.Element {
  const { pathname } = useRouter();
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    let conceptTitle: string = '';
    let descriptionHead: string = '';
    let descriptionTail: string = '';

    if (pathname.includes('/new')) {
      conceptTitle = '신차견적';
      descriptionHead = 'new car';
    } else if (pathname.includes('/leaserent')) {
      conceptTitle = '리스렌트';
      descriptionHead = 'lease or rent car';
    } else if (pathname.includes('/used')) {
      conceptTitle = '중고차';
      descriptionHead = 'old car';
    } else if (pathname.includes('/import')) {
      conceptTitle = '수입차';
      descriptionHead = 'imported car';
    }

    if (pathname.includes('/estimate/')) {
      /* 견적페이지 */
      descriptionTail = ' estimate';
    }
    const pageDescription: string = descriptionHead + descriptionTail;

    setTitle(conceptTitle ? ` | ${conceptTitle}` : '');
    setDescription(pageDescription);
  }, [pathname]);

  return (
    <Head>
      <meta name='keyword' content='estimate car' />
      <meta name='description' content={`${description || 'no name'} page of solecar`} />
      <title>{`쏠카${title}`}</title>
    </Head>
  );
}

export default Seo;
